module.exports = __webpack_public_path__ + "media/images/flags/4x3/can-efb35652c3bec6e7df962ffa283244b3.svg";